const ORBIT_API_ERROR_TITLE = '[ORBIT] API_ERROR';
const GENERIC_ORBIT_API_MESSAGE = 'Error calling Orbit API';

const formatOrbitApiErrorDetails = (payload: unknown): string[] => {
    if (payload == null) return [];

    if (typeof payload === 'string') {
        const trimmed = payload.trim();
        return trimmed ? [trimmed] : [];
    }

    if (Array.isArray(payload)) {
        return payload.flatMap((item) => formatOrbitApiErrorDetails(item));
    }

    if (typeof payload !== 'object') return [];

    const record = payload as Record<string, unknown>;

    for (const key of ['message', 'error', 'detail', 'title', 'orbitMessage']) {
        const formatted = formatOrbitApiErrorDetails(record[key]);
        if (formatted.length > 0) return formatted;
    }

    if (Array.isArray(record.errors)) {
        return record.errors.flatMap((item) =>
            formatOrbitApiErrorDetails(item)
        );
    }

    if (record.errors && typeof record.errors === 'object') {
        return Object.values(record.errors as Record<string, unknown>).flatMap(
            (item) => formatOrbitApiErrorDetails(item)
        );
    }

    return [];
};

export const extractOrbitApiErrorMessage = (
    response?: Record<string, unknown>
): string | undefined => {
    if (!response) return undefined;

    const nestedErrors = (
        response.errors as Record<string, unknown> | undefined
    )?.[ORBIT_API_ERROR_TITLE];
    if (Array.isArray(nestedErrors)) {
        const specific = nestedErrors
            .map((item) => String(item).trim())
            .filter((item) => item && item !== GENERIC_ORBIT_API_MESSAGE);

        if (specific.length > 0) return specific[0];
    }

    const fromPayload = formatOrbitApiErrorDetails(response);
    const specific = fromPayload.filter(
        (item) => item !== GENERIC_ORBIT_API_MESSAGE
    );

    if (specific.length > 0) return specific[0];

    if (
        typeof response.message === 'string' &&
        response.message !== GENERIC_ORBIT_API_MESSAGE
    ) {
        return response.message;
    }

    return undefined;
};
